const _temp0 = require("../block-edits/ani/ani-style.css");

const _temp1 = require("../block-edits/column/column-style.css");

const _temp2 = require("../block-edits/show-hide/show-hide-style.css");

module.exports = {
  "ani":   {
    "ani-": _temp0
  },
  "column":   {
    "column-": _temp1
  },
  "show-hide":   {
    "show-hide-": _temp2
  }
}